/*
Author: Liubo
Date: 2018-09-05
Desc: Vuex 状态管理模块-模板
*/
import cache from "@/assets/js/cache";
export default {
    state: {
        info: JSON.parse(sessionStorage.getItem("_user") || "{}"),
        ismatch: "", // 适当性匹配字段
        assetsList: [], // 持仓列表
        loadFund: false, // 是否已加载基金列表
        suitableList: [], // 待适当性处理协议
        changeParams: {}, // 投资者类型转换参数
        refreshTrigger: 0 // 界面刷新
    },
    getters: {},
    mutations: {
        SET_INFO(state, val) {
            state.info = Object.assign({}, val || {});
            state.ismatch = val.ismatch || "";
            cache.setUser(state.info);
        },
        // 更新我的持仓列表
        updateAssetsList(state, list) {
            state.assetsList = list || [];
        },
        // 是否已加载基金列表
        updateLoadFund(state, val) {
            state.loadFund = val;
        },
        // 更新待适当性处理协议
        updateSuitableList(state, list) {
            state.suitableList = list || [];
        },
        // 更新投资者类型转换参数
        updateChangeParams(state, val) {
            state.changeParams = val || {};
        },
        // 更新view界面
        updateView(state, val) {
            state.refreshTrigger = (state.refreshTrigger + 1) % 10;
        }
    },
    actions: {
        setInfo(context, data) {
            context.commit("SET_INFO", data);
        }
    }
};
